<template>
  <v-dialog v-model="status" max-width="300px" persistent>
    <v-card>
      <v-card-text>
        <div class="body-2">Are you sure want to {{action}}?</div>
        <div class="mt-3 caption font-weight-light">This item will {{action}} immediately. You can't undo this action.</div>
      </v-card-text>

      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat small :disabled="isProcessing" @click.prevent="onClose">Close</v-btn>
        <v-btn color="blue darken-1" flat small :disabled="isProcessing" :loading="isProcessing" @click.prevent="onSuccess">Proceed</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    name: 'ActionDialog',
    props: {
      status: {
        type: Boolean,
        required: true
      },
      action: {
        type: String,
        default: false
      }
    },
    methods: {
      onClose (e) {
        this.$emit("close", e)
      },
      onSuccess (e) {
        this.$emit("success", e)
      }
    }
  }
</script>
